//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.MoveBuilder.js";
import "../CAM/CAM.ReferencePoint.js";
import "../CAM/CAM.ProbeControlParametersBuilder.js";
import "../CAM/CAM.ProbeProtectedParametersBuilder.js";
import "../CAM/CAM.ProbeStockParametersBuilder.js";
import "../CAM/CAM.ProbeToleranceParametersBuilder.js";
let d=[[[0,"Direction",1,0],[0,"Point",1,"Point",0],[1,"PointBuilder",0,"CAM.ReferencePoint",0],[1,"ProbeControlParameters",0,"CAM.ProbeControlParametersBuilder",0],[1,"ProbeProtectedParameters",0,"CAM.ProbeProtectedParametersBuilder",0],[1,"ProbeStockParameters",0,"CAM.ProbeStockParametersBuilder",0],[1,"ProbeToleranceParameters",0,"CAM.ProbeToleranceParametersBuilder",0],[0,"Vector",1,"NXObject",0]],[[[],"ReverseDirection",{},0,0]],[]];
SPLM.CAM.TurnProbeInspectPointMoveBuilder = class extends SPLM.CAM.MoveBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.TurnProbeInspectPointMoveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.TurnProbeInspectPointMoveBuilder.DirectionTypes = Object.freeze({
    "Radial" : "Radial", "Axial" : "Axial", "NormalToCurve" : "NormalToCurve", "Vector" : "Vector"});

export default SPLM;